$(document).ready(function() {
    $('[data-switch-pair-role="switcher"]').change(function (e){
        switcher_pair = $(e.target).data('switch-pair');
        switcher_value = $(e.target).val();

        $('[data-switch-pair-role="lamp"][data-switch-pair="' + switcher_pair + '"]').attr('disabled', 'disabled');
        $('[data-switch-pair-role="lamp"][data-switch-pair="' + switcher_pair + '"][data-switch-pair-on-value="'+ switcher_value +'"]').attr('disabled', null);
    });

    // text-collaos
    $(".collapse-text").each(function() {
      if ($(this).find(".text").height() <= 72) {
        $(this).find(".text").addClass("low-h");
      } else {
        $(this).find(".text").addClass("high-h");
        $(this).find("a.toggle").show();
      }
    })
    

    $(".collapse-text a.toggle").click(function(){

      $(this).parent().toggleClass("show");

      if (!$(this).hasClass("active")) {
        $(this).addClass("active").text("Скрыть");
      } else {
        $(this).removeClass("active").text("Показать все");
      }

      return false;
      
    });

    // menu-burger
    $('div.burger').click(function(){
      if( !$(this).hasClass('open') ){ 
          $(".main-menu").fadeIn();
          $(".header-wrapper").addClass("open");
        openMenu(); 
      } 
      else { 
          closeMenu(); 
          $(".main-menu").fadeOut();
          $(".header-wrapper").removeClass("open");
      }
    }); 

    function openMenu(){       

      $('div.burger').addClass('open'); 
      $('div.x, div.z').addClass('collapse');
      
      setTimeout(function(){ 
        $('div.y').hide(); 
        $('div.x').addClass('rotate30'); 
        $('div.z').addClass('rotate150'); 
      }, 70);
      setTimeout(function(){
        $('div.x').addClass('rotate45'); 
        $('div.z').addClass('rotate135');  
      }, 120);    
    }
      
    function closeMenu(){

      setTimeout(function(){      
        $('div.burger').removeClass('open');  
        $('div.x').removeClass('rotate45').addClass('rotate30'); 
        $('div.z').removeClass('rotate135').addClass('rotate150');       
        
        setTimeout(function(){      
          $('div.x').removeClass('rotate30'); 
          $('div.z').removeClass('rotate150');      
        }, 50);
        setTimeout(function(){
          $('div.y').show(); 
          $('div.x, div.z').removeClass('collapse');
        }, 70);
      }, 100);                          
      
    }

    $('.validate-on-click').click(function(event){
        $(event.target).closest('form').find('[required]').next('.text-danger').remove();

        for (var i = 0, len = $(event.target).closest('form').find('[required]').length; i < len; i++) {
            required_field = $($(event.target).closest('form').find('[required]')[i]);

            if ($(required_field).is(":hidden")) {
                continue;
            }

            if ($(required_field.data('input-field')).length > 0) {
                value_field = $(required_field.data('input-field'));
            } else {
                value_field = required_field;
            }

            if (value_field.val()=='') {
                required_field.after($('#error_span').html());
                event.stopImmediatePropagation();
                event.preventDefault();
            };
        };
    });

    $('body').on('click', '.validate-files-ext', function(event){
        $(event.target).closest('form').find('.file-error-message').remove();

        for (var i = 0, len = $(event.target).closest('form').find('input[data-files-ext-allow]').length; i < len; i++) {
            let file_field = $($(event.target).closest('form').find('input[data-files-ext-allow]')[i]);
            let allowed_extensions = $(file_field).data('files-ext-allow').split(',');

            if ($(file_field).val() == '') {
                continue;
            }

            if (allowed_extensions.indexOf($(file_field).val().split('.').pop().toLowerCase()) > -1) {
                continue;
            }

            event.stopImmediatePropagation();
            event.preventDefault();

            if ($(file_field).closest('form').is('[div-error-placement]')) {
                $(file_field).closest('li').after($('.file-ext-error-text').html());
            } else {
                toastr.error($(file_field).data('files-max-size-error-message'), null, { positionClass: 'toast-top-right', closeButton: true });
            }

            break;
        };
    });

    $('body').on('click', '.validate-files-size', function(event){
        $(event.target).closest('form').find('.file-error-message').remove();

        for (var i = 0, len = $(event.target).closest('form').find('input[data-files-max-size]').length; i < len; i++) {
            let file_field = $($(event.target).closest('form').find('input[data-files-max-size]')[i]);
            let max_file_size = $(file_field).data('files-max-size');

            if ($(file_field).val() == '') {
                continue;
            }

            if (file_field[0].files[0].size <= max_file_size) {
                continue;
            }

            event.stopImmediatePropagation();
            event.preventDefault();

            if ($(file_field).closest('form').is('[div-error-placement]')) {
                $(file_field).closest('li').after($('.file-size-error-text').html());
            } else {
                toastr.error($(file_field).data('files-max-size-error-message'), null, { positionClass: 'toast-top-right', closeButton: true });
            }

            break;
        };
    });

    $('body').on('click', '.remove-error-text', function(event){
        $(event.target).closest('form').find('.file-error-message').remove();
    });

    $(".layout-sidenav .sidenav-item.active").parents(".sidenav-item").addClass("open");
});
